import { message } from 'antd';
import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import createVacancyGroupAPI from '../../api/create-vacancy-group';
import {
  receiveCreateVacancyGroup,
  rejectCreateVacancyGroup,
  requestCreateVacancyGroup,
  requestVacancyGroup,
} from '../actions/admin-page';

interface IGetCityAction {
  type: string;
  payload: {
    title: string;
    description: string;
    division: string;
    searchValue: string;
  }
}
const createVacancyGroup = function* createVacancyGroup(action: IGetCityAction) {
  try {
    yield call(createVacancyGroupAPI, action.payload);
    yield put(requestVacancyGroup({ division: action.payload.division, searchValue: action.payload.searchValue }));
    yield put(receiveCreateVacancyGroup());
    yield message.success({
      content: 'Группа успешно создана',
      style: { textAlign: 'right' },
    });
  } catch (error) {
    yield put(rejectCreateVacancyGroup({ error }));
  }
};

export default function* createVacancyGroupWatcher() {
  yield takeLatest(requestCreateVacancyGroup, createVacancyGroup);
}
